import { PAYMENT_STATUS } from "@elixir/types";
import dayjs from "dayjs";
import {
  PaymentStatusFilterType,
  TReceiptEntitiesWithMeta,
} from "../../types/appointment";
import { TReceiptEntity } from "../../types/billing";
import { TimeFilterType } from "./types";

export const unbilledStatusArray = [PAYMENT_STATUS.UNBILLED];
export const paidStatusArray = [PAYMENT_STATUS.SUCCESS];
export const pendingStatusArray = [
  PAYMENT_STATUS.CREATED,
  PAYMENT_STATUS.CANCELLED,
  PAYMENT_STATUS.FAILED,
];

export const paymentFiltersObj: {
  [k in PaymentStatusFilterType]: {
    id: PaymentStatusFilterType;
    label: string;
    getData: (array: TReceiptEntity[]) => TReceiptEntitiesWithMeta;
  };
} = {
  "all-receipts": {
    id: "all-receipts",
    label: "Total",
    getData: (array: TReceiptEntity[]) => ({
      receiptEntities: array,
    }),
  },
  unbilled: {
    id: "unbilled",
    label: "Unbilled Visits",
    getData: (array: TReceiptEntity[]): TReceiptEntitiesWithMeta => {
      const receiptEntities = array.filter(r =>
        unbilledStatusArray.includes(r.payment_status)
      );

      return { receiptEntities };
    },
  },
  "pending-payment": {
    id: "pending-payment",
    label: "Pending Payment",
    getData: (array: TReceiptEntity[]): TReceiptEntitiesWithMeta => {
      const receiptEntities = array.filter(r =>
        pendingStatusArray.includes(r.payment_status)
      );

      const amount = receiptEntities.reduce(
        (totalSoFar, entity) => totalSoFar + Number(entity.net_amount),
        0
      );

      return { receiptEntities, amount };
    },
  },
  paid: {
    id: "paid",
    label: "Paid",
    getData: (array: TReceiptEntity[]): TReceiptEntitiesWithMeta => {
      const receiptEntities = array.filter(r =>
        paidStatusArray.includes(r.payment_status)
      );

      const amount = receiptEntities.reduce(
        (totalSoFar, entity) => totalSoFar + Number(entity.net_amount),
        0
      );

      return { receiptEntities, amount };
    },
  },
};

export function getTimeFilterMeta(timeFilter: TimeFilterType) {
  switch (timeFilter) {
    case "today": {
      return {
        id: "today",
        label: "Today",
        startDate: dayjs().startOf("day").toISOString(),
        endDate: dayjs().endOf("day").toISOString(),
      };
    }
    case "yesterday": {
      return {
        id: "yesterday",
        label: "Yesterday",
        startDate: dayjs().subtract(1, "days").startOf("day").toISOString(),
        endDate: dayjs().subtract(1, "days").endOf("day").toISOString(),
      };
    }
    case "last-7-days": {
      return {
        id: "last-7-days",
        label: "Last 7 Days",
        startDate: dayjs().subtract(6, "days").startOf("day").toISOString(),
        endDate: dayjs().endOf("day").toISOString(),
      };
    }
  }
}

export function getPaymentStatusMapping(status: PAYMENT_STATUS) {
  switch (status) {
    case PAYMENT_STATUS.UNBILLED:
      return "Unbilled";
    case PAYMENT_STATUS.SUCCESS:
      return "Received";
    case PAYMENT_STATUS.TO_REFUND:
      return "Refund Pending";
    case PAYMENT_STATUS.REFUNDED:
    case PAYMENT_STATUS.REFUND_PROCESSED:
      return "Refunded";
    case PAYMENT_STATUS.CREATED:
      return "Pending";
    case PAYMENT_STATUS.CANCELLED:
      return "Cancelled";
    case PAYMENT_STATUS.FAILED:
      return "Failed";
    default:
  }
}
